import { ethers } from "ethers";
import React, { useCallback, useEffect, useState } from "react";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";
import { AbstractProvider } from "web3-core";

interface IENSContext {
  ens:
    | {
        getName: (address: string) => Promise<{ name: string | null }>;
        getOwner: (name: string) => Promise<string>;
      }
    | undefined;
}

export const ensContext = React.createContext<IENSContext>({
  ens: undefined,
});

export const ENSProvider = ({ children }: { children: React.ReactNode }) => {
  const { provider } = useWeb3Auth();
  const [ens, setENS] = useState<IENSContext["ens"]>(undefined);

  const setup = useCallback(async () => {
    if (!provider) return;

    try {
      // Convert web3 provider to ethers provider
      const ethersProvider = new ethers.providers.Web3Provider(
        provider as AbstractProvider
      );

      setENS({
        getName: async (address: string) => {
          try {
            const name = await ethersProvider.lookupAddress(address);
            return { name };
          } catch (error) {
            console.error("Error resolving ENS name:", error);
            return { name: null };
          }
        },
        getOwner: async (name: string) => {
          try {
            const resolver = await ethersProvider.getResolver(name);
            if (resolver) {
              const address = await resolver.getAddress();
              return address;
            }
            return "0x0000000000000000000000000000000000000000";
          } catch (error) {
            console.error("Error resolving ENS owner:", error);
            return "0x0000000000000000000000000000000000000000";
          }
        },
      });
    } catch (e) {
      console.error("Error setting up ENS provider:", e);
    }
  }, [provider]);

  useEffect(() => {
    setup();
  }, [setup]);

  return <ensContext.Provider value={{ ens }}>{children}</ensContext.Provider>;
};
